export type PayoutStatus = 'active' | 'paused' | 'on_hold';
export type HistoryStatus = 'paid' | 'pending' | 'processing';

export interface PayoutHistoryItem {
  id: number;
  date: string;
  amount: number;
  period: string;
  status: HistoryStatus;
  reference: string;
  campaigns: number;
}

export interface RadioPayout {
  id: number;
  radioName: string;
  frequency: string;
  pendingBalance: number;
  nextPaymentDate: string;
  nextPaymentAmount: number;
  lastPaymentDate: string | null;
  lastPaymentAmount: number | null;
  totalPaidYTD: number;
  status: PayoutStatus;
  paymentMethod: string;
  source: string;
  history: PayoutHistoryItem[];
}

export const radioPayouts: RadioPayout[] = [
  {
    id: 1,
    radioName: 'Radio Nueva Actitud',
    frequency: '87.90 RFW',
    pendingBalance: 18450,
    nextPaymentDate: '2026-07-15',
    nextPaymentAmount: 18450,
    lastPaymentDate: '2026-06-15',
    lastPaymentAmount: 16200,
    totalPaidYTD: 48700,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 101, date: '2026-06-15', amount: 16200, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0601', campaigns: 4 },
      { id: 102, date: '2026-05-15', amount: 14800, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0501', campaigns: 3 },
      { id: 103, date: '2026-04-15', amount: 13200, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0401', campaigns: 3 },
      { id: 104, date: '2026-03-15', amount: 4500, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0301', campaigns: 2 },
    ],
  },
  {
    id: 2,
    radioName: 'Stereo Visión',
    frequency: '94.70 RFW',
    pendingBalance: 22100,
    nextPaymentDate: '2026-07-10',
    nextPaymentAmount: 22100,
    lastPaymentDate: '2026-06-10',
    lastPaymentAmount: 19800,
    totalPaidYTD: 56200,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 201, date: '2026-06-10', amount: 19800, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0610', campaigns: 5 },
      { id: 202, date: '2026-05-10', amount: 17500, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0510', campaigns: 4 },
      { id: 203, date: '2026-04-10', amount: 14200, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0410', campaigns: 4 },
      { id: 204, date: '2026-03-10', amount: 4700, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0310', campaigns: 2 },
    ],
  },
  {
    id: 3,
    radioName: 'Radio Éxito FM',
    frequency: '98.50 RFW',
    pendingBalance: 31500,
    nextPaymentDate: '2026-07-05',
    nextPaymentAmount: 31500,
    lastPaymentDate: '2026-06-05',
    lastPaymentAmount: 28400,
    totalPaidYTD: 78400,
    status: 'active',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 301, date: '2026-06-05', amount: 28400, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0605', campaigns: 6 },
      { id: 302, date: '2026-05-05', amount: 25300, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0505', campaigns: 5 },
      { id: 303, date: '2026-04-05', amount: 19800, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0405', campaigns: 4 },
      { id: 304, date: '2026-03-05', amount: 4900, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0305', campaigns: 2 },
    ],
  },
  {
    id: 4,
    radioName: 'Radio Estéreo Capital',
    frequency: '102.10 RFW',
    pendingBalance: 22400,
    nextPaymentDate: '2026-07-20',
    nextPaymentAmount: 22400,
    lastPaymentDate: '2026-06-20',
    lastPaymentAmount: 19600,
    totalPaidYTD: 51300,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 401, date: '2026-06-20', amount: 19600, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0620', campaigns: 3 },
      { id: 402, date: '2026-05-20', amount: 17800, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0520', campaigns: 3 },
      { id: 403, date: '2026-04-20', amount: 10500, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0420', campaigns: 2 },
      { id: 404, date: '2026-03-20', amount: 3400, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0320', campaigns: 1 },
    ],
  },
  {
    id: 5,
    radioName: 'Radio Cultura Digital',
    frequency: '91.30 RFW',
    pendingBalance: 18200,
    nextPaymentDate: '2026-07-12',
    nextPaymentAmount: 18200,
    lastPaymentDate: '2026-06-12',
    lastPaymentAmount: 16400,
    totalPaidYTD: 42800,
    status: 'active',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 501, date: '2026-06-12', amount: 16400, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0612', campaigns: 3 },
      { id: 502, date: '2026-05-12', amount: 15100, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0512', campaigns: 3 },
      { id: 503, date: '2026-04-12', amount: 8200, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0412', campaigns: 2 },
      { id: 504, date: '2026-03-12', amount: 3100, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0312', campaigns: 1 },
    ],
  },
  {
    id: 6,
    radioName: 'Radio Deportiva Total',
    frequency: '95.70 RFW',
    pendingBalance: 39000,
    nextPaymentDate: '2026-07-08',
    nextPaymentAmount: 39000,
    lastPaymentDate: '2026-06-08',
    lastPaymentAmount: 35200,
    totalPaidYTD: 92400,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 601, date: '2026-06-08', amount: 35200, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0608', campaigns: 8 },
      { id: 602, date: '2026-05-08', amount: 31800, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0508', campaigns: 7 },
      { id: 603, date: '2026-04-08', amount: 19600, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0408', campaigns: 5 },
      { id: 604, date: '2026-03-08', amount: 5800, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0308', campaigns: 3 },
    ],
  },
  {
    id: 7,
    radioName: 'Radio Peninsular',
    frequency: '101.90 RFW',
    pendingBalance: 12950,
    nextPaymentDate: '2026-07-18',
    nextPaymentAmount: 12950,
    lastPaymentDate: '2026-06-18',
    lastPaymentAmount: 11600,
    totalPaidYTD: 31100,
    status: 'active',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 701, date: '2026-06-18', amount: 11600, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0618', campaigns: 2 },
      { id: 702, date: '2026-05-18', amount: 10200, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0518', campaigns: 2 },
      { id: 703, date: '2026-04-18', amount: 6900, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0418', campaigns: 2 },
      { id: 704, date: '2026-03-18', amount: 2400, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0318', campaigns: 1 },
    ],
  },
  {
    id: 8,
    radioName: 'Radio Industria',
    frequency: '93.50 RFW',
    pendingBalance: 26600,
    nextPaymentDate: '2026-07-22',
    nextPaymentAmount: 26600,
    lastPaymentDate: '2026-06-22',
    lastPaymentAmount: 24100,
    totalPaidYTD: 62300,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 801, date: '2026-06-22', amount: 24100, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0622', campaigns: 5 },
      { id: 802, date: '2026-05-22', amount: 21800, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0522', campaigns: 4 },
      { id: 803, date: '2026-04-22', amount: 12400, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0422', campaigns: 3 },
      { id: 804, date: '2026-03-22', amount: 4000, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0322', campaigns: 2 },
    ],
  },
  {
    id: 9,
    radioName: 'Radio Élite Digital',
    frequency: '99.10 RFW',
    pendingBalance: 24500,
    nextPaymentDate: '2026-07-25',
    nextPaymentAmount: 24500,
    lastPaymentDate: '2026-06-25',
    lastPaymentAmount: 21000,
    totalPaidYTD: 55800,
    status: 'on_hold',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 901, date: '2026-06-25', amount: 21000, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0625', campaigns: 4 },
      { id: 902, date: '2026-05-25', amount: 19200, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0525', campaigns: 3 },
      { id: 903, date: '2026-04-25', amount: 11100, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0425', campaigns: 2 },
      { id: 904, date: '2026-03-25', amount: 4500, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0325', campaigns: 2 },
    ],
  },
  {
    id: 10,
    radioName: 'Radio Costa Azul',
    frequency: '88.70 RFW',
    pendingBalance: 17500,
    nextPaymentDate: '2026-07-30',
    nextPaymentAmount: 17500,
    lastPaymentDate: '2026-05-30',
    lastPaymentAmount: 15200,
    totalPaidYTD: 35700,
    status: 'on_hold',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 1001, date: '2026-05-30', amount: 15200, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0530', campaigns: 2 },
      { id: 1002, date: '2026-04-30', amount: 13500, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0430', campaigns: 3 },
      { id: 1003, date: '2026-03-30', amount: 4900, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0330', campaigns: 2 },
      { id: 1004, date: '2026-02-28', amount: 2100, period: 'Enero 2026', status: 'paid', reference: 'PAYOUT-0228', campaigns: 1 },
    ],
  },
  {
    id: 11,
    radioName: 'Radio TechBeats',
    frequency: '97.30 RFW',
    pendingBalance: 20300,
    nextPaymentDate: '2026-07-28',
    nextPaymentAmount: 20300,
    lastPaymentDate: '2026-05-28',
    lastPaymentAmount: 18400,
    totalPaidYTD: 44600,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 1101, date: '2026-05-28', amount: 18400, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0528', campaigns: 3 },
      { id: 1102, date: '2026-04-28', amount: 16400, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0428', campaigns: 3 },
      { id: 1103, date: '2026-03-28', amount: 7200, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0328', campaigns: 2 },
      { id: 1104, date: '2026-02-28', amount: 2600, period: 'Enero 2026', status: 'paid', reference: 'PAYOUT-0228b', campaigns: 1 },
    ],
  },
  {
    id: 12,
    radioName: 'Radio Tropicalísima',
    frequency: '104.60 RFW',
    pendingBalance: 8700,
    nextPaymentDate: '2026-07-03',
    nextPaymentAmount: 8700,
    lastPaymentDate: '2026-06-03',
    lastPaymentAmount: 9200,
    totalPaidYTD: 24100,
    status: 'paused',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 1201, date: '2026-06-03', amount: 9200, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0603', campaigns: 2 },
      { id: 1202, date: '2026-05-03', amount: 8100, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0503', campaigns: 2 },
      { id: 1203, date: '2026-04-03', amount: 5100, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0403', campaigns: 1 },
      { id: 1204, date: '2026-03-03', amount: 1700, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0303', campaigns: 1 },
    ],
  },
  {
    id: 13,
    radioName: 'Radio Urbana 101',
    frequency: '103.50 RFW',
    pendingBalance: 15100,
    nextPaymentDate: '2026-07-14',
    nextPaymentAmount: 15100,
    lastPaymentDate: '2026-06-14',
    lastPaymentAmount: 13800,
    totalPaidYTD: 36400,
    status: 'active',
    paymentMethod: 'Transferencia bancaria',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 1301, date: '2026-06-14', amount: 13800, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0614', campaigns: 3 },
      { id: 1302, date: '2026-05-14', amount: 12500, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0514', campaigns: 3 },
      { id: 1303, date: '2026-04-14', amount: 7500, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0414', campaigns: 2 },
      { id: 1304, date: '2026-03-14', amount: 2600, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0314', campaigns: 1 },
    ],
  },
  {
    id: 14,
    radioName: 'Radio Mix FM',
    frequency: '100.80 RFW',
    pendingBalance: 11300,
    nextPaymentDate: '2026-07-08',
    nextPaymentAmount: 11300,
    lastPaymentDate: '2026-06-08',
    lastPaymentAmount: 10400,
    totalPaidYTD: 27800,
    status: 'active',
    paymentMethod: 'PayPal',
    source: 'Red Publicitaria RFW',
    history: [
      { id: 1401, date: '2026-06-08', amount: 10400, period: 'Mayo 2026', status: 'paid', reference: 'PAYOUT-0608b', campaigns: 2 },
      { id: 1402, date: '2026-05-08', amount: 9600, period: 'Abril 2026', status: 'paid', reference: 'PAYOUT-0508b', campaigns: 2 },
      { id: 1403, date: '2026-04-08', amount: 5800, period: 'Marzo 2026', status: 'paid', reference: 'PAYOUT-0408b', campaigns: 1 },
      { id: 1404, date: '2026-03-08', amount: 2000, period: 'Febrero 2026', status: 'paid', reference: 'PAYOUT-0308b', campaigns: 1 },
    ],
  },
];

export const payoutMetrics = {
  totalPending: 288200,
  totalPaidYTD: 697600,
  activeRadios: 11,
  radiosOnHold: 2,
  radiosPaused: 1,
  nextPayoutDate: '2026-07-15',
  nextPayoutTotal: 172850,
};

export const statusLabels: Record<PayoutStatus, string> = {
  active: 'Activa',
  paused: 'Pausada',
  on_hold: 'En Revisión',
};

export const statusColors: Record<PayoutStatus, string> = {
  active: 'bg-emerald-50 text-emerald-700',
  paused: 'bg-foreground-100 text-foreground-500',
  on_hold: 'bg-amber-50 text-amber-700',
};

export const statusDots: Record<PayoutStatus, string> = {
  active: 'bg-emerald-500',
  paused: 'bg-foreground-400',
  on_hold: 'bg-amber-500',
};

export const historyStatusLabels: Record<HistoryStatus, string> = {
  paid: 'Pagado',
  pending: 'Pendiente',
  processing: 'Procesando',
};

export const historyStatusColors: Record<HistoryStatus, string> = {
  paid: 'bg-emerald-50 text-emerald-700',
  pending: 'bg-amber-50 text-amber-700',
  processing: 'bg-sky-50 text-sky-700',
};